/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Group_DoorInputs */



/**
* | output |
* | --- |
* | "At the door" |
*
* @param {Tools_Group_DoorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_group_door = /** @type {((inputs?: Tools_Group_DoorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Group_DoorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("À l'accueil")
	if (locale === "es") return /** @type {LocalizedString} */ ("En la puerta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Na entrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("All'ingresso")
	return /** @type {LocalizedString} */ ("At the door")
});